module.exports = __webpack_public_path__ + "static/assets/fb4750d2ce4644544dfa45b5aad2f58c.svg";